// Este componente puede moverse a src/features/contacto/Contacto.jsx para modularizar.
import "./contacto.css";

export default function Contacto() {
  return (
    <section className="contacto">
      <h1>Contacto</h1>
      <form action="https://api.whatsapp.com/send?phone=5492616504890&text=Hola,%20quiero%20información%20sobre%20planes" method="get">
        <input type="text" name="nombre" placeholder="Tu nombre" required />
        <input type="email" name="email" placeholder="Tu email" required />
        <textarea name="mensaje" placeholder="Tu mensaje" required></textarea>
        <button type="submit" className="btn">Enviar por WhatsApp</button>
      </form>
    </section>
  );
}
